module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_40.bc343f42.mp3";